import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {Observable} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {delay, distinctUntilChanged} from 'rxjs/operators';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {AppState} from '@store/app.states';
import {selectAdminTangoState} from '@app/4dm1n/tango-cards/_store/tango-cards.selectors';

import {Column} from 'devextreme/ui/data_grid';

import {State as dashState} from './_store/tango-card.reducers';
import {fuseAnimations} from '@fuse/animations';
import {DxDataGridComponent} from 'devextreme-angular';
import {TangoCardsService} from '@app/4dm1n/tango-cards/_store/tango-cards.service';
import {FuseSidebarService} from '../../../@fuse/components/sidebar/sidebar.service';
import {TangoBalanceService} from '@app/4dm1n/tango-cards/services/tango-balance.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {confirm} from 'devextreme/ui/dialog';

@Component({
  selector: 'app-tango-cards',
  templateUrl: './tango-cards.component.html',
  styleUrls: ['./tango-cards.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,

  animations: fuseAnimations
})
export class TangoCardsComponent extends OnDestroyMixin implements OnInit {

  @ViewChild(DxDataGridComponent) historyGrid: DxDataGridComponent;

  orderHistoryColumns: Column[] = [];

  // selectAdminTangoState
  dashboardDatas$: Observable<dashState> = this.store.pipe(
    delay(0),
    select(selectAdminTangoState),
    distinctUntilChanged(),
    untilComponentDestroyed(this),
  );
  displayRefund = false;
  refundMode = true;

  /*
    "billingAddress": {
    "firstName": "firstName",
    "lastName": "lastName",
    "addressLine1": "addressLine1",
    "city": "city",
    "state": "state",
    "postalCode": "postalCode",
    "country": "country",
    "emailAddress": "emailAddress"
  },
   */

  fNewCard: FormGroup = new FormGroup({
    label: new FormControl('', [Validators.required]),
    creditCard: new FormGroup({
      number: new FormControl('', [Validators.required]),
      expiration: new FormControl('', [Validators.required]),
      verificationNumber: new FormControl('', [Validators.required]),
    }),
    billingAddress: new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      addressLine1: new FormControl('', [Validators.required]),
      addressLine2: new FormControl('', []),
      city: new FormControl('', [Validators.required]),
      state: new FormControl('QC', [Validators.required]),
      postalCode: new FormControl('', [Validators.required]),
      country: new FormControl('Canada', [Validators.required]),
      emailAddress: new FormControl('gestion+tangoCard@inbe.ca', [Validators.required, Validators.email]),
    })
  });

  fRefund: FormGroup = new FormGroup({
    creditCardToken: new FormControl<string>(null, [Validators.required]),
    amount: new FormControl<number>(2500, [Validators.required]),
  });

  constructor(
    private cdr: ChangeDetectorRef,
    private store: Store<AppState>,
    private tangoCardsService: TangoCardsService,
    private _fuseSidebarService: FuseSidebarService,
    public tangoBalanceService: TangoBalanceService,
  ) {
    super();
    this._fuseSidebarService.getSidebar('navbar')?.fold();
  }

  ngOnInit(): void {

    // this.dashboardDatas$.pipe(untilComponentDestroyed(this)).subscribe((datas) => {
    //
    //   this.cdr.markForCheck();
    //
    // });

    // {
    //   "referenceOrderID": "RA201204-28640-33",
    //   "customerIdentifier": "inbe2",
    //   "accountIdentifier": "inbe2",
    //   "accountNumber": "CQ5XCvEXyo",
    //   "amountCharged": {
    //     "value": 50,
    //     "currencyCode": "USD",
    //     "exchangeRate": 1.29332,
    //     "total": 38.66
    // },
    //   "utid": "U121653",
    //   "rewardName": "Visa* Prepaid Card",
    //   "sender": {
    //   "firstName": "Inbe (Gift Card)",
    //     "lastName": "",
    //     "email": "info+reward@inbe.ca"
    // },
    //   "recipient": {
    //   "email": "tutu@gmail.com",
    //     "firstName": "tutu@gmail.com",
    //     "lastName": ""
    // },
    //   "emailSubject": "lkjlkj",
    //   "message": "lkjlkjlj",
    //   "sendEmail": true,
    //   "etid": "E000000",
    //   "status": "COMPLETE",
    //   "campaign": "Direct 4dm1n Card",
    //   "createdAt": "2020-12-04T00:43:29.081Z"
    // },
    // {
    //   "referenceOrderID": "RA201203-28639-81",
    //   "customerIdentifier": "inbe2",
    //   "accountIdentifier": "inbe2",
    //   "accountNumber": "CQ5XCvEXyo",
    //   "amountCharged": {
    //   "value": 50,
    //     "currencyCode": "USD",
    //     "exchangeRate": 1.29332,
    //     "total": 38.66
    // },
    //   "utid": "U121653",
    //   "rewardName": "Visa* Prepaid Card",
    //   "sender": {
    //   "firstName": "Inbe (Gift Card)",
    //     "lastName": "",
    //     "email": "info+reward@inbe.ca"
    // },
    //   "recipient": {
    //   "email": "tutu@gmail.com",
    //     "firstName": "tutu@gmail.com",
    //     "lastName": ""
    // },
    //   "emailSubject": "lkjlkj",
    //   "message": "lkjlkjlj",
    //   "sendEmail": true,
    //   "etid": "E000000",
    //   "status": "COMPLETE",
    //   "campaign": "Direct 4dm1n Card",
    //   "createdAt": "2020-12-03T23:33:06.579Z"
    // },


    this.orderHistoryColumns = [
      {
        dataField: 'createdAt',
        dataType: 'datetime',
        caption: 'Envoi',
        sortIndex: 0,
        sortOrder: 'desc',
      },
      {
        dataField: 'recipient.email',
      },
      {
        dataField: 'amountCharged.value',
        caption: 'Amount',
        customizeText: (cellInfo) => {
          return `$${cellInfo.value} USD`;
        }
      },
      {
        dataField: 'referenceOrderID',
        visible: false,
      },
      {
        dataField: 'rewardName',
        caption: 'Reward name'
      },
      {
        dataField: 'referenceOrderID',
        caption: 'Reference Order',
        cellTemplate: 'referenceOrderIDTemplate',
      },
    ];

  }

  resendOrder(referenceOrderID: string) {

    console.log(referenceOrderID);
    return confirm(
      `Resend tangocard for reference ${referenceOrderID} ?`,
      'Resend tango Card'
    )
      .then((dialogResult) => {
          if (dialogResult) {
            this.tangoCardsService.resendCard(referenceOrderID);
          }
        }
      );

  }


  displayRefundPopup() {
    this.tangoBalanceService.refreshCreditCards();
    this.displayRefund = true;
  }

  switchRefundMode() {
    this.refundMode = !this.refundMode;
  }

  addCard() {
    this.tangoBalanceService.addCreditCard(this.fNewCard.getRawValue());
    this.refundMode = false;
  }

  creditCardUnregisters(token) {

    confirm(
      'Cannot undo!',
      'Delete credit card ?'
    ).then((dialogResult) => {
      if (dialogResult) {
        this.tangoBalanceService.creditCardUnregisters(token);
      }
    });

  }


  creditCardDeposits() {

    const {creditCardToken, amount} = this.fRefund.getRawValue();

    confirm(
      'Cannot undo - Ask Daniel/Eric if you don\'t know what you are doing....',
      `Add ${amount} USD to credit card ?`
    ).then((dialogResult) => {
      if (dialogResult) {
        this.tangoBalanceService.creditCardDeposits(creditCardToken, amount);
      }
    });

  }
}
